import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface LearningRecommendationsProps {
  recommendations: string[];
}

export const LearningRecommendations = ({ recommendations }: LearningRecommendationsProps) => {
  if (!recommendations.length) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Learning Recommendations</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {recommendations.map((recommendation, index) => (
            <Alert key={index}>
              <AlertDescription>{recommendation}</AlertDescription>
            </Alert>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};